import { useEffect, useState } from 'react'
import { Utensils } from 'lucide-react'
import Calendar from '../../../../components/ERP/Calendar/Calendar'
import Modal from '../../../../components/ERP/Modal/Modal'
import TimePicker from '../../../../components/ERP/TimePicker/TimePicker'
import { toDateInputValue } from '../../../../utils/dateUtils'

function formatIso(value) {
  return String(value).split('-').reverse().join('/')
}

function periodLabel(start, end) {
  if (!start) return 'Um clique marca o dia. Outro clique, em outra data, abre o período.'
  if (!end || end === start) return formatIso(start)
  return `${formatIso(start)} a ${formatIso(end)}`
}

function NutritionPlaceModal({ isOpen, plate, saving, error, onClose, onConfirm }) {
  const [start, setStart] = useState('')
  const [end, setEnd] = useState('')
  const [time, setTime] = useState('12:00')

  useEffect(() => {
    if (!isOpen) return
    setStart('')
    setEnd('')
    setTime('12:00')
  }, [isOpen, plate?.id])

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Colocar na linha do tempo"
      subtitle={plate ? plate.name : 'Prato'}
      icon={<Utensils size={22} />}
      size="large"
      footer={(
        <button
          type="button"
          className="btn-primary"
          disabled={saving || !start || !end || !time}
          onClick={() => onConfirm({ startDate: start, endDate: end, time })}
        >
          {saving ? 'Salvando...' : 'Agendar prato'}
        </button>
      )}
    >
      {error && <p className="patients-alert-strip">{error}</p>}
      <div className="nut-place">
        <Calendar
          key={plate?.id || 'plate'}
          mode="range"
          compact
          title="Período"
          subtitle="Início e fim"
          onRangeSelect={(rangeStart, rangeEnd) => {
            const startValue = rangeStart ? toDateInputValue(rangeStart) : ''
            setStart(startValue)
            setEnd(rangeEnd ? toDateInputValue(rangeEnd) : startValue)
          }}
        />
        <div className="nut-place-time">
          <label>Horário</label>
          <TimePicker value={time} onChange={setTime} title="Horário da refeição" />
          <p className="patients-muted">
            {periodLabel(start, end)}
            {time ? ` · ${time}` : ''}
          </p>
        </div>
      </div>
    </Modal>
  )
}

export default NutritionPlaceModal
